class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.content = this.summary.nextElementSibling;
    this.hoverCloseTimer = null;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));

    this.summary.addEventListener('pointerenter', (e) => {
      if (e.pointerType === 'mouse') this.openViaHover();
    });
    this.mainDetailsToggle.addEventListener('pointerleave', (e) => {
      if (e.pointerType === 'mouse') this.scheduleClose(150);
    });
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement) && !this.mainDetailsToggle.matches(':hover')) {
        this.close();
      }
    }, 0);
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();
    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((a) => a.play());
      this.summary.setAttribute('aria-expanded', 'true');
    } else {
      this.animations.forEach((a) => a.cancel());
      this.summary.setAttribute('aria-expanded', 'false');
    }
  }

  openViaHover() {
    clearTimeout(this.hoverCloseTimer);
    if (!this.mainDetailsToggle.hasAttribute('open')) {
      this.mainDetailsToggle.setAttribute('open', '');
      this.onToggle();
    }
  }

  scheduleClose(delay = 150) {
    clearTimeout(this.hoverCloseTimer);
    this.hoverCloseTimer = setTimeout(() => {
      // stäng bara om varken fokus eller hover finns kvar
      if (!this.mainDetailsToggle.matches(':hover') && !this.contains(document.activeElement)) {
        this.close();
      }
    }, delay);
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.summary.setAttribute('aria-expanded', 'false');
    if (this.animations) this.animations.forEach((a) => a.cancel());
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    super.onToggle();
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;
    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
